module.exports = __webpack_public_path__ + "media/images/emblems/Onnens-coat_of_arms-cd26c743e1df7823682a332b3f1608f7.svg";